import React from 'react';

const IconReplacementBattery = () => (
    <svg width="20px" height="20px" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
        <g fillRule="nonzero" fill="none">
            <path fill="#333" d="M8 5h34v45H8zM19 0h11v5H19z" />
            <path
                fill="#FFF"
                d="M26.933 27.035l3.43.518-9.533 15.265 1.6-16.035-3.43-.518L28.534 11z"
            />
        </g>
    </svg>
);

export default IconReplacementBattery;
